exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#containerComandSMS[data-v-c427d582] {\n  width: 100%;\n}\n", ""]);

// exports
